import { ComponentType } from "react";
import { useTranslation } from "react-i18next";
import { PurchasePolicyDisclaimer } from "./purchase-policy-disclaimer";
import { Form } from "./type";

interface Props {
  onActivateSubscription: any;
  onActivateSubscriptionError(error: string): void;
  form: ComponentType<Form>;
  subscriptionId: string;
}

export function InactiveForm(props: Props) {
  const { t } = useTranslation();

  const {
    onActivateSubscription,
    onActivateSubscriptionError,
    form: Form,
    subscriptionId,
  } = props;

  const introComponent = <PurchasePolicyDisclaimer />;

  return (
    <Form
      status="INACTIVE"
      introComponent={introComponent}
      onSuccess={onActivateSubscription}
      onError={onActivateSubscriptionError}
      btnText={t("update")}
      subscriptionId={subscriptionId}
    />
  );
}

export default InactiveForm;
